import { z } from 'zod';

const timestamp = z.iso.datetime({ offset: true });

/** A person's name: trimmed, 1–80 characters. */
export const personNameSchema = z.string().trim().min(1, 'Required').max(80, 'Max 80 characters');

/** A row of public.profiles. */
export const profileSchema = z.object({
  user_id: z.uuid(),
  first_name: z.string(),
  last_name: z.string(),
  created_at: timestamp,
  updated_at: timestamp,
});
export type Profile = z.infer<typeof profileSchema>;

/** Input for editing the caller's own names. */
export const updateProfileInputSchema = z.object({
  firstName: personNameSchema,
  lastName: personNameSchema,
});
export type UpdateProfileInput = z.infer<typeof updateProfileInputSchema>;

/** `options.data` sent with an organic signup; the signup trigger builds the profile and personal org from it. */
export const signUpMetadataSchema = z.object({
  first_name: personNameSchema,
  last_name: personNameSchema,
  country: z.string().length(2),
});
export type SignUpMetadata = z.infer<typeof signUpMetadataSchema>;
